import useSWRV from 'swrv';
import {watch} from 'vue';

/**
 * useSWRVを利用しやすくするためのラッパー関数
 *
 * @param key
 * @param fetcher
 */
export default function useFetch(key, fetcher) {
  const { data, error, isValidating, mutate } = useSWRV(key, fetcher, {
    shouldRetryOnError: false,
    revalidateOnFocus: true,
  });

  watch(error, (error) => {
    if (error) {
      throw error;
    }
  });

  return {
    data,
    error,
    isValidating,
    mutate,
  };
}
